import { Input } from '@web-app/components/ui/Input/input';
import {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';

import type { NewGoalInputProps, NewGoalInputRef } from './types';

export const NewGoalInput = forwardRef<NewGoalInputRef, NewGoalInputProps>(
  (
    { onSubmit, placeholder = 'Enter a SMART goal...', isDisabled = false },
    ref,
  ) => {
    const [value, setValue] = useState('');
    const inputRef = useRef<HTMLInputElement>(null);

    useImperativeHandle(ref, () => ({
      focus: () => {
        inputRef.current?.focus();
      },
    }));

    const handleSubmit = useCallback(() => {
      const trimmed = value.trim();
      if (trimmed) {
        onSubmit(trimmed);
        setValue('');
      }
    }, [value, onSubmit]);

    const handleKeyDown = useCallback(
      (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
          handleSubmit();
        }
      },
      [handleSubmit],
    );

    return (
      <Input
        ref={inputRef}
        data-testid="new-goal-input"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onBlur={handleSubmit}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        disabled={isDisabled}
        className="h-8 text-sm"
      />
    );
  },
);

NewGoalInput.displayName = 'NewGoalInput';
